import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  tab: {
    color: theme.vars.palette.text.secondary,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.75rem',
      minWidth: '3rem'
    }
  }
}));

export default useStyles;
